import gallery1 from './component/assets/gallery1.jpg';
import gallery2 from './component/assets/gallery2.jpg';
import gallery3 from './component/assets/gallery3.jpg';
import gallery4 from './component/assets/gallery4.jpg';
import map from './component/assets/Map.png'


export const Aboutuscontent = [
    {
        id: 1,
        lang: "eng",
        title: "About Us",
        desc: "Bun Vit 281 is the traditional cuisine in Tan Binh, Ho Chi Minh city specializing in Bun Mang Vit. We are proud of our tradition from my grandmother since 1968. With a delicious soup from baked bone and deliciousness unique in duck meat, we commit that all customers who come in here will not be disappointed. Welcome!"
    },
    {   
        id: 2,
        lang: "vie",
        title : "Về Chúng Tôi",
        desc: "Bún Vịt 281 là quán ăn gia đình tại quận Tân Bình, TP Hồ Chí Minh với món bún măng vịt đặc trưng. Chúng tôi tự hào khi là quán ăn truyền thống của gia đình từ năm 1968. Với nước dùng ngọt hầm từ xương cùng với độ béo và thơm của thịt vịt, chúng tôi cam đoan rằng quý khách đến dùng sẽ không thấy thất vọng. Kính mời."
    }
    
]

export const Mapcontent = [
    {
        id:1,
        img: map
    }
]


export const Gallerycontent = [
    {
        id:1,
        img: gallery1,
        url: "https://vnexpress.net/quan-bun-mang-vit-moi-ngay-chi-ban-mot-tieng-3500253.html",
        featureL: true,
    },
    {
        id:2,
        img: gallery2,
        url: "https://tripzone.vn/ck9829-bun-vit-hem-281-le-van-sy",
        featureL: true,

    },
    {
        id:3,
        img: gallery3,
        url: "https://riviu.vn/quan-bun-vit-50-nam-chi-ban-trong-vong-1-tieng-het-sach",
        featureL: true,

    },
    {
        id:4,
        img: gallery4,
        url: "https://thanhnien.vn/di-an-bun-vit-tranh-thu-o-tan-binh-post597819.html",
        featureL: true,

    },

]